module.exports = __webpack_public_path__ + "img/qrcode1.304e0b02.jpg";